import { useFormik } from "formik";
import React from "react";
import {
  ListaIndicadoresDePresenca,
  ListaRedespacho,
  ListaRoteiro,
  ListaTipoFrete,
  ListaTransportadora,
  Transportadora,
} from "../../../types/AbaTransportadora";
import { InputNumerico } from "../../inputs/InputNumerico";
import clsx from "clsx";
import { classeParaLabelsFormularioComFundoEscuro } from "../../../estilos/classeParaLabelsFormularioComFundoEscuro";
import globalMU from "globalMU";
import { Select } from "@mui/material";

const estiloAbaTransportadora =
  require("./aba-transportadora.module.scss").default;
const estilosFormulario = require('../../../estilos/formulario.module.scss').default

export type AbaTransportadoraProps = {
  listaTransportadora: ListaTransportadora[];
  listaRedespacho: ListaRedespacho[];
  listaTipoFrete: ListaTipoFrete[];
  listaRoteiro: ListaRoteiro[];
  listaIndicadoresDePresenca: ListaIndicadoresDePresenca[]; // 458066
  transportadora: Transportadora;
  onAplicar: (transportadora: Transportadora) => void;
  permitirAlterarRoteiro: boolean;
  utilizaCalculoFreteFaixaMarkup: string;
  habilitaEdicaoCustoFrete: boolean;
  custoFretePendente: boolean;
  somenteLeitura: boolean;
  onValorAlterado: (dados: Transportadora) => void
};

export const AbaTransportadora = (props: AbaTransportadoraProps) => {
  const formik = useFormik({
    initialValues: { ...props.transportadora },
    onSubmit: (values, { }) => { },
    enableReinitialize: true,
  });

  const campoTransportadora = <>
    <label style={{ paddingLeft: "80px", paddingTop: "10px" }}
    title="Veja parâmetros: &#013;-Ordenar lista de transportadora por código&#013;-Código da Transportadora Padrão"
    >Transportadora</label>
    <select
        style={{marginTop: "10px"}}
        className={estiloAbaTransportadora.select}
        name="CodigoTransportadora"
        title="Veja parâmetros: &#013;-Ordenar lista de transportadora por código&#013;-Código da Transportadora Padrão"
        id="AbaTransportadora_campoTransportadora"
        value={formik.values.CodigoTransportadora ?? ''}
        disabled={props.somenteLeitura}
        autoFocus
        onChange={(e) => {
            formik.setFieldValue("CodigoTransportadora", e.target.value)
            props.onValorAlterado({
              ...formik.values,
              CodigoTransportadora: e.target.value
            })
        }}
    >
      <option>Selecione</option>
      {props.listaTransportadora?.map((f) => (
        <option key={f.Codigo} value={f.Codigo}>
          {f.Nome}
        </option>
      ))}
    </select>
  </>

  const campoRedespacho = <>
    <label title="Veja parâmetro [Ordenar lista de transportadora por código]">Redespacho</label>
    <select
        style={{paddingTop: "5px"}}
        className={estiloAbaTransportadora.select}
        name="CodigoTransportadoraRedespacho"
        id="AbaTransportadora_campoRedespacho"
        title="Veja parâmetro [Ordenar lista de transportadora por código]"
        value={formik.values.CodigoTransportadoraRedespacho ?? ''}
        disabled={props.somenteLeitura}
        onChange={(e) => {
            formik.setFieldValue(
                "CodigoTransportadoraRedespacho",
                e.target.value
            )
          props.onValorAlterado({
            ...formik.values,
            CodigoTransportadoraRedespacho: e.target.value
          })
        }}
    >
      <option>Selecione</option>
      {props.listaRedespacho?.map((f) => (
        <option key={f.Codigo} value={f.Codigo}>
          {f.Nome}
        </option>
      ))}
    </select>
  </>
  const campoTipoFrete = <>
    <label title="Veja parâmetro [Tipo de Frete Padrão]"
    >Tipo de Frete</label>
    <select
         title="Veja parâmetro [Tipo de Frete Padrão]"
        style={{ minWidth: "355px", paddingTop: "5px" }}
        className={estiloAbaTransportadora.select}
        name="TipoFrete"
        value={(formik.values.TipoFrete == null ? '' : Number(formik.values.TipoFrete)) ?? ""}
        disabled={props.somenteLeitura}
        onChange={(e) => {
          formik.setFieldValue("TipoFrete", e.target.value)
          props.onValorAlterado({
            ...formik.values,
            TipoFrete: e.target.value
          })
        }}
    >
      <option>Selecione</option>
      {props.listaTipoFrete?.map((f) => (
        <option key={f.Codigo} value={f.Codigo}>
          {f.Descricao}
        </option>
      ))}
    </select>
  </>

  const campoRoteiro = <>
    <label>Roteiro</label>
    <select
        style={{ minWidth: "300px", paddingTop: "5px" }}
        className={estiloAbaTransportadora.select}
        name="CodigoRoteiroEntrega"
        id="AbaTransportadora_campoRoteiro"
        onChange={(e) => {
            formik.setFieldValue("CodigoRoteiroEntrega", e.target.value)
            props.onValorAlterado({
              ...formik.values,
              CodigoRoteiroEntrega: e.target.value
            })
        }}
        value={formik.values.CodigoRoteiroEntrega ?? ''}
        disabled={!props.permitirAlterarRoteiro || props.somenteLeitura}
    >
      <option>Selecione</option>
      {props.listaRoteiro?.map((f) => (
        <option key={f.Codigo} value={f.Codigo}>
          {`${f.Codigo} - ${f.Nome}`}
        </option>
      ))}
    </select>
  </>

  const campoIndicadorPresenca = <>
    <label
       //style={{ paddingLeft: "80px", paddingTop: "10px" }}
      id="AbaTransportadora_labelIndicadorPresenca" // 458066
    >Indicador de Presença
    </label>
    <select
      className={estiloAbaTransportadora.select}
      name="IndicadorDePresenca"
      id="AbaTransportadora_campoIndicadorPresenca"
      value={formik.values.CodigoIndicadorDePresenca ?? ''}
      title={
          formik.values.CodigoIndicadorDePresenca 
              ? ` ${
                  props.listaIndicadoresDePresenca?.find(
                      i => i.Codigo === formik.values.CodigoIndicadorDePresenca
                  )?.Descricao+' - '+formik.values.CodigoIndicadorDePresenca || ''
                }` 
              : ''
      }
      disabled={props.somenteLeitura}
      autoFocus
      onChange={(e) => {
          const selectedOption = props.listaIndicadoresDePresenca?.find(
              i => i.Codigo === e.target.value
          );
          
          formik.setFieldValue("CodigoIndicadorDePresenca", e.target.value);
          props.onValorAlterado({
              ...formik.values,
              CodigoIndicadorDePresenca: e.target.value
          });
          
          // Atualiza o title com a descrição do item selecionado
          e.target.title = selectedOption 
              ? `${selectedOption.Descricao} - ${selectedOption.Codigo}` 
              : '';
      }}
  >
      <option value="">Selecione</option>
      {props.listaIndicadoresDePresenca?.map((i) => (
          <option key={i.Codigo} value={i.Codigo}>
              {`${i.Descricao?.trimEnd()} - ${i.Codigo?.trimEnd()}`}
          </option>
      ))}
  </select>
  </>

  const campoClassificacaoFrete = <>
    <label>Classificação Frete</label>
    <input
      style={{ maxWidth: "171px", paddingTop: "5px" }}
      name="ClassificacaoFrete"
      id="AbaTransportadora_campoClassificacaoFrete"
      onChange={formik.handleChange}
      value={(formik.values.ClassificacaoFrete) ?? ""}
      disabled
    />
    <label
      title="Veja parâmetro &#013;Utiliza calculo do custo de frete por faixa de markup?&#013;-Permite frete nas vendas para entrega na expedição"
    >Custo Frete</label>
    <InputNumerico
        style={
          props.custoFretePendente
              ? { color: "red", maxWidth: "171px" }
              : { color: "black", maxWidth: "171px" }
        }
        permitirValorNegativo={false}
        onValorModificado={(valor) => {
            if (valor < 0) {
              globalMU.showErrorMessage("O valor do custo de frete não pode ser negativo.")
              formik.setFieldValue("ValorCustoFrete", 0)
              return false
            }
            formik.setFieldValue("ValorCustoFrete", valor)
            props.onValorAlterado({
              ...formik.values,
              ValorCustoFrete: valor
            })
        }}
        valor={formik.values.ValorCustoFrete}
        disabled={!props.habilitaEdicaoCustoFrete || props.somenteLeitura}
    />
  </>

  return (
    <>
      <div className={estiloAbaTransportadora.separador}>
        <div className={clsx(estilosFormulario.formulario, classeParaLabelsFormularioComFundoEscuro)}>
          
          {campoTransportadora}

          {campoRedespacho}

          {campoTipoFrete}

          {campoRoteiro}

          {props.utilizaCalculoFreteFaixaMarkup == "S" 
              && campoClassificacaoFrete}

          {props?.listaIndicadoresDePresenca?.length > 0 
              && campoIndicadorPresenca} {/* 458066 */}

        </div>
        {!props.somenteLeitura && (
          <div className={estiloAbaTransportadora.buttonAbaTransportadora}>
            <br />
            <button onClick={() => props.onAplicar(formik.values)}
                id="AbaTransportadora_btnAplicar"
              >
              Aplicar
            </button>
          </div>
        )}
      </div>
      {<section style={{ marginBottom: "30px" }} />}
    </>
  );
};
